/**
 * FIQ-1658: exports the affected tasks behind one data-quality warning to an Excel workbook.
 * Callers pass the full (uncapped) task list; fetching it is the drawer's responsibility.
 *
 * @param {object} params
 * @param {string} params.alertId - Data-quality alert id (e.g. "zero-duration")
 * @param {Array} params.tasks - Flagged task rows to export
 * @param {number} [params.total] - True affected-task count; adds a "plus N more" row when it exceeds the rows
 * @param {string} params.currencySymbol
 * @param {string} params.regimeName - Used in the file name
 */
import { buildFlaggedTaskExportRows, getDataQualityCategoryLabel } from "./data-quality-detail-utils"
import { saveWorkbookForExport } from "./save-workbook-for-export"

export async function exportDataQualityTasksToExcel({ alertId, tasks, total, currencySymbol, regimeName }) {
    const rows = buildFlaggedTaskExportRows(alertId, tasks, currencySymbol, total)
    if (!rows.length) return

    const xlsx = await import("xlsx")
    const { utils } = xlsx
    const workbook = utils.book_new()
    const worksheet = utils.json_to_sheet(rows)
    const keys = Object.keys(rows[0])
    worksheet["!cols"] = keys.map((key) => ({
        wch: rows.reduce((w, r) => Math.max(w, `${r[key] ?? ""}`.length), key.length + 2),
    }))
    utils.book_append_sheet(workbook, worksheet, "Affected Tasks")

    const category = getDataQualityCategoryLabel(alertId)
    const name = sanitiseFileName(regimeName || "Regime")
    const dateStr = new Date().toISOString().split("T")[0]
    await saveWorkbookForExport({
        workbook,
        fileName: `Affected Tasks -- ${category} -- ${name} -- ${dateStr}.xlsx`,
        xlsx,
    })
}

function sanitiseFileName(name) {
    return name.replace(/[<>:"/\\|?*]/g, "_")
}
